export function onlyUnique<T extends unknown[]>(
  value: number | string,
  index: number,
  self: T
): boolean {
  return self.indexOf(value) === index;
}
